@if (eulaList && eulaList.length > 0) {
@for (eula of eulaList; track eula) {
<button class="btn mb10" (click)="selectDoc(eula)"
  [ngClass]="_currentData.eula_title == eula.eula_title ? 'custom-border' : ''">{{eula.eula_title}}</button>
}
}


<div class="row" style="height: 75vh;">
  <div class="col-sm-12 col-md-12 col-lg-12 col-12">
    <div class="outer-container">
      <div>
        @if (_currentData && !_currentData.eula_document_details) {
        <pdf-viewer [config]="_currentData"></pdf-viewer>
        }
        @if (_currentData && _currentData.eula_document_details) {
        <div class="document-view" [innerHtml]="_currentData.eula_document_details | safeStyleHtml"></div>
        }
      </div>
    </div>
  </div>
</div>

<!-- } -->